import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'aco',
} as IModuleProps;
